import React, { Component } from 'react'
import View from '@common/View'
import { Link } from 'react-router'
import style from './style.module.less'
export default class extends Component {
  render() {
    return (
      <View header="优秀范例">
        <div className={style.example}>
          <h3 className={style.title}>推荐橱窗优秀范例</h3>
          <p className={style.item}>
            商家可以通过设计海报使用推荐橱窗举办促销活动、提供特色服务、为主推套餐进行引流等，推荐橱窗的海报将会显示在商家店铺主页首屏。优秀的推荐橱窗设计除了能带来更多的点击、吸引更多的用户参与活动外，更能提升店铺的调性，塑造店铺的整体品牌形象。
          </p>
          <div className={style.image}>
            <img src="//qnm.hunliji.com/o_1ckp9btb51v6la6q9dkp9oq1j7.png" />
          </div>
          <p className={style.item}>
            推荐橱窗通过精美的海报设计能更好的触动用户，极大的提升用户点击欲望，为主推套餐引流之外，还可以唤起私信咨询直接获得客资，玩法也更加的丰富。
          </p>
          <div className={style.image}>
            <img src="//qnm.hunliji.com/o_1ckp9cis61rad1rjp1n2o1umbc6ac.png" />
            <img src="//qnm.hunliji.com/o_1ckp9j3n11ggq1r7n1fpsia91uijh.png" />
          </div>
          <p className={style.desc}>
            除了以上几种玩法之外，还有更多的精彩的玩法等待你去发掘，赶快去设置推荐橱窗吧~
          </p>
          <div className={style.btn_wrap}>
            <Link className={style.btn} to={'/localMerchant/showCase'}>
              去设置
            </Link>
          </div>
        </div>
      </View>
    )
  }
}
